// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { TimeBaseEntity } from '../time-base-entity';
import { TimeEntry } from './time-entry';
import { TimeEntryImport } from './time-entry-import';
import { TimeEntryImportBillDetail } from './time-entry-import-bill-detail';
import { TimeEntryType } from './time-entry-type';
import { UserTypeRate } from './user-type-rate';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TimeEntryImportDetail extends TimeBaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  category1?: string;
  category1Id?: number;
  category2?: string;
  category2Id?: number;
  category3?: string;
  category3Id?: number;
  createdAt!: Date;
  createdBy?: string;
  entryDateTime!: Date;
  errors!: boolean;
  jobId!: number;
  jobType?: string;
  jobTypeId!: number;
  notes?: string;
  reference?: string;
  timeEntryId?: number;
  timeEntryImportId!: number;
  timeEntryTypeId!: number;
  timeRateId?: number;
  total?: number;
  ts?: any;
  units?: number;
  updatedAt!: Date;
  updatedBy?: string;
  user?: string;
  userId?: number;
  userTypeId?: number;
  warnings!: boolean;
  timeEntry!: TimeEntry;
  timeEntryImport!: TimeEntryImport;
  timeEntryImportBillDetails!: TimeEntryImportBillDetail[];
  timeEntryType!: TimeEntryType;
  userTypeRate!: UserTypeRate;
}

